import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CompanyDto, UserCompanyView } from './al-company-v2.service';

export interface UserCompanyDto {
	id: number;
	creationDate: string;
	companyId: number;
	userId: number;
	isOwner: boolean;
}

export interface UserCompanyCreateDto {
	companyId: number;
	userId: number;
	isOwner: boolean;
}

export interface UserCompanyUpdateDto {
	id: number;
	companyId: number;
	userId: number;
	isOwner: boolean;
}

@Injectable({
	providedIn: 'root'
})
export class AlUserCompanyV2Service {
	url: string = 'v2/usercompanies';

	constructor(private http: HttpClient) {}

	// CRUD start
	public getAll(): Observable<UserCompanyDto[]> {
		return this.http.get<UserCompanyDto[]>(`${this.url}`);
	}

	public post(company: UserCompanyCreateDto): Observable<UserCompanyDto> {
		return this.http.post<UserCompanyDto>(`${this.url}`, company);
	}

	public put(company: UserCompanyUpdateDto): Observable<UserCompanyDto> {
		return this.http.put<UserCompanyDto>(`${this.url}/${company.id}`, company);
	}

	public delete(companyId: number): Observable<void> {
		return this.http.delete<void>(`${this.url}/${companyId}`);
	}
	// CRUD end

	public getViewElement(id: number): Observable<UserCompanyView> {
		return this.http.get<UserCompanyView>(`${this.url}/userCompaniesView/${id}`);
	}

	public getView(): Observable<UserCompanyView[]> {
		return this.http.get<UserCompanyView[]>(`${this.url}/userCompaniesView`);
	}
}
